// Note: Sandbox View
import React, { useState } from "react";
import {
	Text,
	Box,
	Button,
	Flex,
	Grid,
	GridItem,
	HStack,
	Spacer,
	Select,
	Slider,
	SliderTrack,
	SliderFilledTrack,
	SliderThumb,
	SliderMark,
} from "@chakra-ui/react";
import { FaUndo, FaRedo } from "react-icons/fa";
import { RxCounterClockwiseClock } from "react-icons/rx";
import {
	Icon,
	Input,
	Stack,
	VStack,
} from "@chakra-ui/react/dist/chakra-ui-react.cjs";

const btnStyle = {
	py: "14px",
	px: "35px",
	ml: "10px",
	fontSize: { base: "12px", md: "16px" },
};
const TopBar = () => {
	return (
		<HStack spacing={4} pt={{ base: "120px", md: "75px" }}>
			<Select
				placeholder="API Name"
				variant="unstyled"
				w={{ base: "100px", md: "200px" }}
				fontSize={{ base: "15px", md: "24px" }}
				fontWeight="bold"
				padding="5px"
			>
				<option value="api1">API 1</option>
				<option value="api2">API 2</option>
			</Select>
			<Spacer />
			<Flex justify="flex-end">
				<Select placeholder="Load a preset">
					<option value="preset1">Preset 1</option>
					<option value="preset2">Preset 2</option>
				</Select>
				<Button {...btnStyle}>Save</Button>
				<Button {...btnStyle}>View Code</Button>
				<Button {...btnStyle}>Share</Button>
			</Flex>
		</HStack>
	);
};

const DashboardGrid = () => {
	const [sliderValue, setSliderValue] = useState(10);
	const font = { base: "15px", md: "24px" };
	return (
		<Grid
			templateColumns={{
				base: "1fr",
				md: "1fr 2fr 1fr",
			}}
			h="70vh"
			gap={4}
			mt={4}
		>
			<GridItem>
				<Box bg="#303038" h="100%" borderRadius="16px">
					<Text fontSize="2xl" p={4}>
						System
					</Text>
				</Box>
			</GridItem>
			<GridItem>
				<Box h="100%">
					<Flex direction="column" h="100%">
						<Flex
							direction="column"
							gap={7}
							fontSize={{ base: "15px", md: "21px" }}
						>
							<Text>
								<strong>User </strong> Hello!
							</Text>
							<Text>
								<strong>Assistant </strong> Hi, how can I help you?
							</Text>
							<HStack>
								<Text>
									<h3>User</h3>
								</Text>
								<Input
									bg="#3D3D44"
									borderRadius="16px"
									placeholder="Type your message here"
								/>
							</HStack>
							<Text>
								<strong>+</strong> Add message
							</Text>
						</Flex>

						<Flex
							direction="row"
							gap={3}
							mt={{ base: "10px", md: 0 }}
							alignItems="center"
						>
							<Button
								py={{ base: "10px", md: "24px" }}
								px={{ base: "10px", md: "20px" }}
								mt={{ base: "10px", md: "5px" }}
								bgGradient="linear(to-r, #16BF5D, #0A9141)"
							>
								Submit
							</Button>
							<HStack spacing={3} mt={{ base: "5px", md: 0 }}>
								<Icon as={FaUndo} />
								<Icon as={FaRedo} />
								<Icon as={RxCounterClockwiseClock} />
							</HStack>
						</Flex>
					</Flex>
				</Box>
			</GridItem>
			<GridItem>
				<Stack direction={"column"} gap={3}>
					<Stack direction={"column"}>
						<Text fontSize={font}>Index Selection</Text>
						<Select
							placeholder="Select"
							size="lg"
							bg="#3D3D44"
							borderRadius="16px"
							color="#D0D0D0"
						>
							<option value="option1">Option 1</option>
							<option value="option2">Option 2</option>
							<option value="option3">Option 3</option>
						</Select>
					</Stack>
					<Stack direction={"column"}>
						<Text fontSize={font}>Mode</Text>
						<Select
							placeholder="Select"
							size="lg"
							bg="#3D3D44"
							borderRadius="16px"
							color="#D0D0D0"
						>
							<option value="option1">Option 1</option>
							<option value="option2">Option 2</option>
							<option value="option3">Option 3</option>
						</Select>
					</Stack>
					<Stack direction={"column"}>
						<Text fontSize={font}>Model</Text>
						<Select
							placeholder="Select"
							size="lg"
							bg="#3D3D44"
							borderRadius="16px"
							color="#D0D0D0"
						>
							<option value="option1">Option 1</option>
							<option value="option2">Option 2</option>
							<option value="option3">Option 3</option>
						</Select>
					</Stack>
					<Stack direction={"column"}>
						<HStack>
							<Text fontSize={font}>K level</Text>
							<Spacer />
							<Button>{sliderValue}</Button>
						</HStack>
						<Slider
							aria-label="slider-ex-1"
							onChange={(val) => setSliderValue(val)}
							defaultValue={sliderValue}
						>
							<SliderTrack>
								<SliderFilledTrack />
							</SliderTrack>
							<SliderThumb />
						</Slider>
					</Stack>
					<Stack direction={"column"}>
						<HStack>
							<Text fontSize={font}>Temperature</Text>
							<Spacer />
							<Button>1</Button>
						</HStack>
						<Slider aria-label="slider-ex-1" defaultValue={30}>
							<SliderTrack>
								<SliderFilledTrack />
							</SliderTrack>
							<SliderThumb />
						</Slider>
					</Stack>
					<Stack direction={"column"}>
						<HStack>
							<Text fontSize={font}>Maximum length</Text>
							<Spacer />
							<Button>1</Button>
						</HStack>
						<Slider aria-label="slider-ex-1" defaultValue={30}>
							<SliderTrack>
								<SliderFilledTrack />
							</SliderTrack>
							<SliderThumb />
						</Slider>
					</Stack>
					<Stack direction={"column"}>
						<HStack>
							<Text fontSize={font}>Top P</Text>
							<Spacer />
							<Button>1</Button>
						</HStack>
						<Slider aria-label="slider-ex-1" defaultValue={30}>
							<SliderTrack>
								<SliderFilledTrack />
							</SliderTrack>
							<SliderThumb />
						</Slider>
					</Stack>
				</Stack>
			</GridItem>
		</Grid>
	);
};

function Sandbox() {
	return (
		<Box p={4}>
			<TopBar />
			<DashboardGrid />
		</Box>
	);
}

export default Sandbox;
